import React from "react";
import {
  Card,
  Page,
  Layout,
  Stack,
  Link,
  SkeletonDisplayText,
  SkeletonBodyText,
  TextContainer,
  FooterHelp,
  Text,
} from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";

export default function PlanShowSkeleton(props) {
  return (
    <Page>
      <TitleBar title="Plan" secondaryActions={[]} />
      <Layout>
        <Layout.Section>
          <Card
            primaryFooterAction={{
              content: "Change plan",
              loading: true,
              url: "/settings/plan/edit",
            }}
          >
            <Card.Section>
              <Stack alignment="trailing">
                <Stack.Item fill>
                  <Stack vertical spacing="tight">
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={1} />
                  </Stack>
                </Stack.Item>
              </Stack>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={6} />
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.Section>
      </Layout>
      <FooterHelp>
        <Text variant="bodyMd" as="span">Manage or change your Locations So Super plan. View our{" "}
          <Link url="https://www.sosuper.app/terms/">terms of service</Link>{" "}and{" "}
          <Link url="https://www.sosuper.app/privacy/">privacy policy</Link>
        </Text>
      </FooterHelp>
    </Page>
  );
}
